(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mtp-product-accordions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mtp-product-accordions')) {
  customElements.define('mtp-product-accordions', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Map();
      this.querySelectorAll('[data-mtp-specs] li').forEach(item => {
        const label = item.firstElementChild;
        if (!label || label.tagName !== 'STRONG' || label.previousSibling?.textContent.trim()) return;
        const remainder = label.nextSibling;
        if (!remainder || remainder.nodeType !== Node.TEXT_NODE || !/^\s*:\s*/.test(remainder.textContent)) return;
        const value = document.createElement('span');
        while (label.nextSibling) value.append(label.nextSibling);
        value.firstChild.textContent = value.firstChild.textContent.replace(/^\s*:\s*/, ' ');
        item.append(value);
        item.classList.add('mtp-product-specs__row');
        item.parentElement.classList.add('mtp-product-specs');
      });
      this.addEventListener('click', event => {
        const summary = event.target.closest('.mtp-product-accordion__summary');
        if (!summary || summary.parentElement.parentElement !== this) return;
        event.preventDefault();
        event.stopPropagation();
        this.togglePanel(summary.parentElement);
      }, { signal: this.controller.signal });
    }
    togglePanel(details) {
      const previous = this.animations.get(details);
      const expand = previous ? !previous.expand : !details.open;
      const startHeight = details.getBoundingClientRect().height;
      if (previous) {
        previous.animation.onfinish = null;
        previous.animation.cancel();
        this.animations.delete(details);
      }
      const summary = details.querySelector('summary');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expand;
        delete details.dataset.mtpExpanded;
        details.style.overflow = '';
        return;
      }
      details.open = true;
      details.dataset.mtpExpanded = String(expand);
      details.style.overflow = 'hidden';
      const border = parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
      const endHeight = expand ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      const animation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 220, easing: 'cubic-bezier(0.2, 0, 0, 1)' }
      );
      this.animations.set(details, { animation, expand });
      animation.onfinish = () => {
        details.open = expand;
        delete details.dataset.mtpExpanded;
        details.style.overflow = '';
        this.animations.delete(details);
      };
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.animations?.forEach(({ animation, expand }, details) => {
        animation.onfinish = null;
        animation.cancel();
        details.open = expand;
        delete details.dataset.mtpExpanded;
        details.style.overflow = '';
      });
      this.animations?.clear();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mtp-product-gallery-follow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mtp-product-gallery-follow')) {
  customElements.define('mtp-product-gallery-follow', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => {
        this.row = this.closest('.shopify-section')?.querySelector('.t4s-main-product__content.is--layout_default .t4s-row__product');
        this.info = this.row?.querySelector(':scope > .t4s-product__info-wrapper');
        this.gallery = this.row?.querySelector('.t4s-product__media-wrapper > .t4s-row');
        if (!this.info || !this.gallery) return;
        this.originalAttributes = new Map(['tabindex', 'role', 'aria-labelledby'].map(name => [name, this.info.getAttribute(name)]));
        this.media = matchMedia('(min-width: 1025px) and (min-height: 650px)');
        const options = { signal: this.controller.signal };
        this.media.addEventListener('change', () => this.scheduleUpdate(), options);
        window.addEventListener('resize', () => this.scheduleUpdate(), options);
        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(() => this.scheduleUpdate());
          this.observer.observe(this.gallery);
        }
        this.updateLayout();
      });
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateLayout());
    }
    updateLayout() {
      if (!this.row?.isConnected) return;
      if (!this.media.matches) {
        this.restoreLayout();
        return;
      }
      const top = Math.max(0, this.row.getBoundingClientRect().top + window.scrollY);
      const height = Math.max(280, Math.min(720, window.innerHeight - top - 24));
      this.row.style.setProperty('--mtp-product-pane-height', Math.round(height) + 'px');
      const firstActivation = !this.row.classList.contains('mtp-product-split');
      this.row.classList.add('mtp-product-split');
      if (firstActivation) {
        this.resizeFrame = requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }
      this.info.tabIndex = 0;
      this.info.setAttribute('role', 'region');
      const heading = this.info.querySelector('h1');
      if (heading) {
        if (!heading.id) heading.id = 'mtp-product-pane-' + this.closest('.shopify-section').id;
        this.info.setAttribute('aria-labelledby', heading.id);
      }
    }
    restoreLayout() {
      this.row?.classList.remove('mtp-product-split');
      this.row?.style.removeProperty('--mtp-product-pane-height');
      this.originalAttributes?.forEach((value, name) => {
        if (value === null) this.info.removeAttribute(name);
        else this.info.setAttribute(name, value);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resizeFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.restoreLayout();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-klarna-information"] && !Shopify.designMode) return;
  try {
    class ShopKlarnaInformation extends HTMLElement {
  connectedCallback() {
    if (this.closest('product-card, quick-add-dialog, [data-ref="popup-content"]')) {
      this.hidden = true;
      return;
    }
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('.shop-klarna-information__more');
    if (!this.dialog || !this.trigger || !this.dialog.showModal || this.events) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.trigger.addEventListener('click', event => {
      event.preventDefault();
      this.wasLocked = document.body.classList.contains('overflow-hidden');
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.dialog.scrollTop = 0;
      document.body.classList.add('overflow-hidden');
    }, options);
    this.querySelectorAll('[data-shop-klarna-close]').forEach(button => {
      button.addEventListener('click', () => this.dialog.close(), options);
    });
    this.dialog.addEventListener('click', event => {
      const rect = this.dialog.getBoundingClientRect();
      if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => {
      this.trigger.setAttribute('aria-expanded', 'false');
      if (!this.wasLocked) document.body.classList.remove('overflow-hidden');
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }, options);
  }
  disconnectedCallback() {
    if (this.dialog?.open && !this.wasLocked) document.body.classList.remove('overflow-hidden');
    this.events?.abort();
    this.events = null;
  }
}
if (!customElements.get('shop-klarna-information')) customElements.define('shop-klarna-information', ShopKlarnaInformation);
  } catch(e) { console.error(e); }
})();

})();
